module.exports = __webpack_public_path__ + "img/b2db071.jpg";